import type { IconProps } from './icon.types'

const ShieldIcon = (props: IconProps) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.1'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='shield-icon'
    {...props}
  >
    <path d='M9 1.8l5.5 2.2v4c0 3.4-2.3 6.4-5.5 7.4-3.2-1-5.5-4-5.5-7.4v-4z' />
    <path d='M6.6 9l1.7 1.7L11.6 7' />
  </svg>
)

export default ShieldIcon
